import 'slick-carousel';
import BMI from './bmi';
import BMR from './bmr';
import NutritionLog from './nutrition-log';
import Interventions from './interventions';
import Planer from './planer';
import Implementation from './implementation';
import Difference from './difference';

class Form {
    index = 0;
    bmiCalculator = null;
    bmrCalculator = null;
    nutritionLog = null;
    interventions = null;
    implementations = [];
    planer = null;
    lastIndex = 7;

    stateClasses = {
        button: {
            completed: 'form-navigation__button--completed',
            disabled: 'form-navigation__button--disabled'
        },
    };

    constructor($el) {
        this.$el = $el;
        this.$next = $('[data-form="next"]');
        this.$navButton = $('[data-form-navigation="button"]');
        this.$submit = $('[data-form="submit"]');
        this.$draft = $('[data-form="draft"]');
        this.$cancel = $('[data-form="cancel"]');
        this.$step = $('[data-form="step"]');
        this.hasErrors = this.$el.data('error') ? true : false;
        this.$error = this.$el.find('[data-form="error"]');
        this.$alerts = this.$el.find('[data-form="alert"]');
        this.$jumplink = this.$el.find('[data-form="jumplink"]');
        this.$formControls = this.$el.find('.form-control');
        this.$visitTypeSelect = this.$el.find('[id="visit_type_id"]');
        this.$visitPhone = this.$el.find('#visit_1');
		this.$grip_strength = this.$el.find('#grip_strength');
		this.$calf_circumference = this.$el.find('#calf_circumference');
        this.init();
    }

    init = () => {
        // prevent enter submit
        $(document).on("keydown", ":input:not(textarea)", function (event) {
            return event.key != "Enter";
        });

        this.$next.on('click', this.nextClickHandler);
        this.$navButton.on('click', this.navButtonClickHandler);
        this.$jumplink.on('click', this.jumpLinkClickHandler);
        this.initSlick();
        this.disableTabbing();

        // init bmi
        if ($('[data-bmi="el"]').length) {
            this.bmiCalculator = new BMI($('[data-bmi="el"]'));
        }

        // init difference components
        if ($('[data-difference="el"]').length) {
            $('[data-difference="el"]').each((i, el) => {
                new Difference($(el));
            });
        }

        // init bmr
        if ($('[data-bmr="el"]').length) {
            this.bmrCalculator = new BMR($('[data-bmr="el"]'), this.bmiCalculator);
        }

        // init nutrition log
        if ($('[data-nutrition-log="el"]').length) {
            this.nutritionLog = new NutritionLog($('[data-nutrition-log="el"]'), this.bmrCalculator);
        }

        // init interventions
        if ($('[data-interventions="el"]').length) {
            this.interventions = new Interventions($('[data-interventions="el"]'));
            this.interventions.$el.on('heightChanged', this.heightChangeHandler);
        }

        // init implementations
        if ($('[data-implementation="el"]').length) {
            $('[data-implementation="el"]').each((i, el) => {
                this.implementations.push(new Implementation($(el)));
            });
        }

        // init planer
        if ($('[data-planer="el-6"]').length) {
            new Planer($('[data-planer="el-6"]'), this.nutritionLog, this.interventions, this.implementations);
        }
        if ($('[data-planer="el"]').length) {
            this.planer = new Planer($('[data-planer="el"]'), this.nutritionLog, this.interventions, this.implementations);
        }

        // handle errors
        if (this.hasErrors) {
            this.handleErrors();
        }

        // vist type change handler
        this.$visitTypeSelect.on('change', this.visitTypeChangeHandler);

        this.visitTypeChangeHandler();


    }

    visitTypeChangeHandler = (e) => {
		console.log('visit type changed');
		let visit_id = this.$visitTypeSelect.val();
        if (visit_id == 3 || visit_id == 4 || visit_id == 5) {
            this.$visitPhone.prop("disabled", true);
        } else {
            this.$visitPhone.prop("disabled", false);;
        }

		// Faustschlusskraft & Wadenumfang
		if(visit_id == 2) {
			this.$grip_strength.prop("disabled", true);
			this.$calf_circumference.prop("disabled", true);
		} else {
			this.$grip_strength.prop("disabled", false);
			this.$calf_circumference.prop("disabled", false);
		}
    }

    jumpLinkClickHandler = (e) => {
        const index = $(e.target).data('index');
        this.$el.slick('slickGoTo', index);
    }

    handleErrors = () => {
        // goto last slide
        this.$el.slick('slickGoTo', this.lastIndex);

        // loop through slides
        this.$step.each((i, step) => {
            if ($(step).find('.invalid-feedback').length) {
                $(`[data-form="alert"][data-index="${i}"]`).removeClass('d-none');
            }
        });

        const sliderHeight = $('div[data-slick-index="7"]').outerHeight(true);
        // $(".slick-list").height(sliderHeight);
        $(".slick-list").animate({ height: sliderHeight });
    }

    initSlick = () => {
        this.$el.slick({
            adaptiveHeight: true,
            speed: 500,
            draggable: false,
            swipe: false,
            infinite: false,
            dots: false,
            arrows: false,
        });

        this.$el.on('afterChange', this.slideChangeHandler);
        this.updateNavigation();

    }

    disableTabbing = () => {
        this.$formControls.each((i, el) => {
            $(el).attr('tabindex', '-1');
        });
    }

    nextClickHandler = () => {
        this.$el.slick('slickNext');
    }

    navButtonClickHandler = (e) => {
        const index = $(e.target).data('index');
        this.$el.slick('slickGoTo', index);
    }

    slideChangeHandler = (slick, currentSlide) => {
        const index = currentSlide.currentSlide;
        this.index = index;
        this.updateNavigation();
    }

    updateNavigation = () => {
        const classes = this.stateClasses.button;
        this.$navButton.each((i, el) => {
            if ($(el).data('index') < this.index) {
                $(el).removeClass(classes.disabled);
                $(el).addClass(classes.completed);
            } else if ($(el).data('index') > this.index) {
                $(el).addClass(classes.disabled);
                $(el).removeClass(classes.completed);
            } else {
                $(el).removeClass(classes.disabled);
                $(el).removeClass(classes.completed);
            }
        });

        // first slide ?
        if (this.index == 0) {
            this.$draft.addClass('d-none');
            this.$cancel.removeClass('d-none');
        } else {
            this.$draft.removeClass('d-none');
            this.$cancel.addClass('d-none');
        }

        // last slide ?
        if (this.index == this.lastIndex) {
            this.$next.addClass('d-none');
            // this.$draft.removeClass('d-none');
            this.$submit.removeClass('d-none');
        } else {
            this.$next.removeClass('d-none');
            // this.$draft.addClass('d-none');
            this.$submit.addClass('d-none');
        }
    }
}

export default Form;
